import { useQuery } from '@apollo/client';
import { Box } from '@material-ui/core';
import { MySessionsType } from 'containers/my_sessions/types';
import { GET_MY_SESSIONS } from 'graph_ql/styling_session/queries';
import { useMemo } from 'react';
import styles from './upcoming-styling-sessions.module.scss';
import { getUserProfilePhoto } from 'utils/getUserProfilePhoto';
import utils from 'utils/utils';
import { PATH } from 'routes/constant';
import { useHistory } from 'react-router-dom';
import SectionHeading from './SectionHeading';
import { Spinner } from 'react-bootstrap';
import {
    resetRequestQuiz,
    setRequestQuizPath,
    setRequestQuizUpdatePage,
} from 'redux/style_request_quiz/requestQuiz.slice';
import { useDispatch } from 'react-redux';
import { REQUEST_PATH, SESSION_QUIZ_PATH } from 'containers/session_quiz/constants';

export const UpcomingStylingSessionsCard = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const searchVariables = {
        type: MySessionsType.ALL,
        paging: {
            size: 200,
            page: 0,
        },
    };

    const { data: mySessionsData, loading } = useQuery(GET_MY_SESSIONS, {
        variables: {
            input: searchVariables,
        },
        fetchPolicy: 'no-cache',
    });

    const listSessions = useMemo(() => {
        if (mySessionsData?.getMySessions?.data) {
            return mySessionsData?.getMySessions?.data;
        } else {
            return [];
        }
    }, [mySessionsData]);

    const renderSessionCard = ({ session, index }) => {
        return (
            <Box
                key={index}
                className={styles.sessionCard}
                onClick={() => {
                    history.push(`${PATH.STYLE_REQUEST}/${session?.taffiId}`);
                }}
            >
                <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                    <img
                        alt="section-icon"
                        className={styles.sessionCardAvaImg}
                        src={getUserProfilePhoto(session?.stylist)}
                    />
                    <Box className={styles.sessionCardName}>
                        {session?.stylist?.firstName} {session?.stylist?.lastName}
                    </Box>
                </Box>
                <Box className={styles.sessionDescription}>
                    <p className={styles.sessionDescriptionText}>
                        {session?.stylingSessionReason?.isSomethingElse
                            ? session?.subReason?.substring(0, 20).trimEnd()
                            : session?.stylingSessionReason?.value}
                        {session?.subReason?.length >= 20 && '...'}
                    </p>
                    {session?.needSessionWithStylist !== false && (
                        <p className={styles.sessionDateTime}>
                            {utils.getSessionSchedulingStartTime(session?.startTime)}
                        </p>
                    )}
                </Box>
            </Box>
        );
    };

    if (!loading && listSessions.length <= 0) {
        return null;
    }

    return (
        <Box className={styles.sectionContainer}>
            <SectionHeading
                title="Your Style Requests"
                onClick={() => {
                    history.push(PATH.MY_STYLE_REQUESTS);
                }}
            />
            {loading ? (
                <div className="d-flex justify-content-center">
                    <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />
                </div>
            ) : listSessions.length <= 0 ? (
                <Box className={styles.sectionEmptyContainer}>
                    <Box className={styles.sectionEmptyLabel}>You have no style requests.</Box>
                    <Box
                        className={styles.sectionEmptyButton}
                        onClick={() => {
                            dispatch(resetRequestQuiz());
                            dispatch(setRequestQuizUpdatePage(false));
                            dispatch(setRequestQuizPath(SESSION_QUIZ_PATH.SESSION_PURPOSE));
                            history.push(`${PATH.STYLE_REQUEST_QUIZ}/?path=${REQUEST_PATH.SESSION_PURPOSE.param}`);
                        }}
                    >
                        Schedule a Style Request
                    </Box>
                </Box>
            ) : (
                <>{listSessions.slice(0, 3).map((session, index) => renderSessionCard({ session, index }))}</>
            )}
        </Box>
    );
};
